import { useContext } from "react";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useUserCardUpdate } from "../../hooks/useUserCardUpdate";
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { AddressBook } from "./AddressBook";
// MUI
import Box from "@mui/material/Box";

export const UserAddress = ({ userCard, defaultAddressCode }) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);
  // Update User Card Mutation
  const { mutate, isSuccess, data } = useUserCardUpdate();
  // Success Function
  const successFunc = () => {
    setAlertNotification({
      message: `Default address set`,
      severity: "info",
    });
  };
  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  const handleSetDefault = (addressCode) => {
    mutate({
      data: {
        user: {
          name: userCard.name,
          phoneno: userCard.phoneno,
          email: userCard.email,
          defaultshiptocode: addressCode,
          entitlementreport: userCard.entitlementreport,
          adminid: userCard.adminid,
        },
      },
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 800,
        mt: 2,
      }}
    >
      <AddressBook
        handleSetDefault={handleSetDefault}
        defaultAddressCode={defaultAddressCode}
      />
    </Box>
  );
};
